export enum BadgeVariants {
  primary = 'primary',
  secondary = 'secondary',
  secondaryDiscrete = 'secondaryDiscrete',
  attention = 'attention',
  plain = 'plain',
  outline = 'outline',
  header = 'plain header-color',
}
